module.exports = __webpack_public_path__ + "img/our-leadership.66499414.png";